<script>
	import { createEventDispatcher } from 'svelte';
	import Icon from '../icons/Icon.svelte';

	const dispatch = createEventDispatcher();

	export let categories = [];
	export let products = [];
	export let selectedCategoryId = "all";

	function handleOpenNewCategoryModal() {
		dispatch('openNewCategoryModal');
	}

	function handleOpenNewProductModal() {
		dispatch('openNewProductModal');
	}

	function handleToggleCategory(cat) {
		dispatch('toggleCategory', cat);
	}

	function handleOpenEditCategoryModal(cat) {
		dispatch('openEditCategoryModal', cat);
	}

	function handleToggleProduct(prod) {
		dispatch('toggleProduct', prod);
	}

	function handleOpenEditProductModal(prod) {
		dispatch('openEditProductModal', prod);
	}
</script>

<div class="accordion-layout">
			<div class="accordion-actions-bar">
				<button type="button" class="btn-secondary-outline" on:click={handleOpenNewCategoryModal}>
					+ Nova Categoria
				</button>
				<button type="button" class="btn-primary-action" on:click={handleOpenNewProductModal}>
					+ Novo Produto
				</button>
			</div>

			<div class="accordion-container">
				{#each categories as cat (cat.id)}
					<div class="accordion-section {!cat.active ? 'paused' : ''}">
						<div class="accordion-header" on:click={() => (selectedCategoryId = cat.id)}>
							<div class="acc-left">
								{#if cat.image}
									<img src={cat.image} alt={cat.name} class="acc-cat-thumb" />
								{:else}
									<div class="acc-icon-badge">
										<Icon name="utensils" size={18} color="#FF6A00" />
									</div>
								{/if}
								<div>
									<h4>{cat.name} ({products.filter(p => p.categoryId === cat.id).length} produtos)</h4>
									<p class="acc-desc">{cat.description || "Sem descrição informada"}</p>
								</div>
							</div>
							<div class="acc-right" on:click|stopPropagation>
								<button type="button" class="status-badge-btn {cat.active ? 'active' : 'paused'}" on:click={() => handleToggleCategory(cat)}>
									{cat.active ? "Ativa" : "Pausada"}
								</button>
								<button type="button" class="btn-outline-small" on:click={() => handleOpenEditCategoryModal(cat)}>Editar Categoria</button>
							</div>
						</div>

						<div class="accordion-body">
							<div class="accordion-products-grid">
								{#each products.filter(p => p.categoryId === cat.id) as prod (prod.id)}
									<div class="card-item-box {!prod.active ? 'paused' : ''}">
										<div class="card-item-img-wrapper">
											{#if prod.image}
												<img src={prod.image} alt={prod.name} class="accordion-prod-img" />
											{:else}
												<div class="card-item-no-img">
													<Icon name="utensils" size={22} color="#94A3B8" />
												</div>
											{/if}
											{#if prod.promoPrice > 0}
												<span class="promo-tag">PROMOÇÃO</span>
											{/if}
										</div>

										<div class="card-item-body">
											<div class="card-item-top">
												<span class="card-item-title">{prod.name}</span>
												<div class="card-item-price-stock">
													<span class="card-item-price">
														R$ {(prod.promoPrice > 0 ? prod.promoPrice : prod.price).toFixed(2)}
													</span>
													{#if prod.track_stock}
														{#if (prod.stock_quantity ?? 0) <= 0}
															<span class="admin-stock-pill stock-out">Esgotado</span>
														{:else}
															<span class="admin-stock-pill stock-available">{prod.stock_quantity} un.</span>
														{/if}
													{/if}
												</div>
											</div>
											<p class="card-item-desc">{prod.description}</p>
										</div>

										<div class="card-item-actions">
											<button type="button" class="btn-toggle-stock {prod.active ? 'in' : 'out'}" on:click={() => handleToggleProduct(prod)}>
												{#if prod.active}
													<Icon name="check" size={12} /> Disponível
												{:else}
													<Icon name="x" size={12} /> Pausado
												{/if}
											</button>
											<button type="button" class="btn-edit-item" on:click={() => handleOpenEditProductModal(prod)}>Editar</button>
										</div>
									</div>
								{/each}
							</div>
						</div>
					</div>
				{/each}
			</div>
		</div>

<style>
	/* ========================================================
	   LAYOUT 2: ACORDEÃO PANORÂMICO
	   ======================================================== */
	.accordion-layout {
		flex: 1;
		overflow-y: auto;
		padding: 20px 24px;
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.accordion-actions-bar {
		display: flex;
		align-items: center;
		gap: 10px;
		justify-content: flex-end;
	}

	.accordion-container {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.accordion-section {
		background: #FFFFFF;
		border: 1px solid #E2E8F0;
		border-radius: 12px;
		overflow: hidden;
	}

	.accordion-section.paused {
		opacity: 0.6;
	}

	.accordion-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 14px 18px;
		background: #F8FAFC;
		border-bottom: 1px solid #E2E8F0;
		cursor: pointer;
	}

	.acc-left {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.acc-cat-thumb {
		width: 40px;
		height: 40px;
		border-radius: 8px;
		object-fit: cover;
	}

	.acc-icon-badge {
		width: 40px;
		height: 40px;
		border-radius: 8px;
		background: #FFF7ED;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.acc-left h4 {
		margin: 0;
		font-size: 15px;
		font-weight: 700;
		color: #0F172A;
	}

	.acc-desc {
		margin: 2px 0 0 0;
		font-size: 12px;
		color: #64748B;
	}

	.acc-right {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.status-badge-btn {
		padding: 4px 10px;
		border-radius: 12px;
		font-size: 11px;
		font-weight: 700;
		border: 1px solid transparent;
		cursor: pointer;
	}

	.status-badge-btn.active {
		background: #DCFCE7;
		color: #166534;
	}

	.status-badge-btn.paused {
		background: #F1F5F9;
		color: #64748B;
	}

	.btn-outline-small {
		padding: 4px 10px;
		border: 1px solid #CBD5E1;
		background: #FFFFFF;
		border-radius: 6px;
		font-size: 11px;
		font-weight: 600;
		cursor: pointer;
	}

	.accordion-body {
		padding: 16px;
	}

	.accordion-products-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
		gap: 14px;
	}

	.card-item-box {
		background: #FFFFFF;
		border: 1px solid #E2E8F0;
		border-radius: 10px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	.card-item-box.paused {
		opacity: 0.6;
	}

	.card-item-img-wrapper {
		position: relative;
		width: 100%;
		height: 120px;
		background: #F1F5F9;
	}

	.accordion-prod-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.card-item-no-img {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.promo-tag {
		position: absolute;
		top: 6px;
		left: 6px;
		background: #FF6A00;
		color: #FFFFFF;
		font-size: 9px;
		font-weight: 800;
		padding: 2px 6px;
		border-radius: 6px;
	}

	.card-item-body {
		padding: 10px;
		flex: 1;
	}

	.card-item-top {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 4px;
	}

	.card-item-title {
		font-size: 13px;
		font-weight: 700;
		color: #0F172A;
	}

	.card-item-price {
		font-size: 13px;
		font-weight: 800;
		color: #FF6A00;
	}

	.card-item-desc {
		margin: 0;
		font-size: 11px;
		color: #64748B;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.card-item-actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 8px 10px;
		background: #F8FAFC;
		border-top: 1px solid #F1F5F9;
	}

	.btn-toggle-stock {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		padding: 3px 8px;
		border-radius: 6px;
		font-size: 10px;
		font-weight: 700;
		cursor: pointer;
		border: none;
	}

	.btn-toggle-stock.in {
		background: #DCFCE7;
		color: #166534;
	}

	.btn-toggle-stock.out {
		background: #F1F5F9;
		color: #64748B;
	}

	.btn-edit-item {
		padding: 3px 8px;
		background: #FFFFFF;
		border: 1px solid #CBD5E1;
		border-radius: 6px;
		font-size: 11px;
		font-weight: 600;
		cursor: pointer;
	}
	.card-item-price-stock {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.admin-stock-pill {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		font-size: 11px;
		font-weight: 700;
		padding: 2px 7px;
		border-radius: 6px;
		line-height: 1.2;
		white-space: nowrap;
	}

	.admin-stock-pill.stock-available {
		background: #F1F5F9;
		color: #475569;
		border: 1px solid #E2E8F0;
	}

	.admin-stock-pill.stock-out {
		background: #FEE2E2;
		color: #B91C1C;
		border: 1px solid #FECACA;
	}

</style>
